import { css } from 'styled-components';
export const CustomScrollCss = css `
  /* This part is for the scrollbar track (the gutter) */
  ::-webkit-scrollbar-track {
    background: transparent; /* Makes the track (gutter) transparent */
  }

  /* This is for the scrollbar handle */
  ::-webkit-scrollbar-thumb {
    background: #2c2f30; /* Color of the scrollbar itself */
    border-radius: 10px; /* Optional: to make the scrollbar corners rounded */
  }

  /* This is for the scrollbar handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #111; /* Color when the scrollbar is hovered over */
  }

  /* This is for the scrollbar width and height */
  ::-webkit-scrollbar {
    width: 6px; /* Width of the vertical scrollbar */
    height: 6px; /* Height of the horizontal scrollbar */
  }
`;
